import axios from 'axios';
import { obtenerToken } from './helpers/tokenSesion';
import { URL_API } from './pwa/constantesPwa';

// La URL de la API sale de REACT_APP_API_BASE_URL (ver .env / .env.local):
// así el build de producción (que lee .env, comprometido en git) siempre
// apunta al dominio real, y en desarrollo local basta con tener un
// .env.local (gitignored) con la URL de tu backend local — sin depender de
// comentar/descomentar una línea a mano antes de cada commit, que es
// justo lo que rompió producción la última vez.
const instance = axios.create({
	baseURL: URL_API,
	headers: {
		'Content-Type': 'application/json',
		// Añadir más encabezados si es necesario
	},
	// Si es necesario, puedes agregar credenciales, tiempo de espera, etc.
	// withCredentials: true,
	// timeout: 1000,
	//  withCredentials: true,
});

// El token se lee en cada petición (no una sola vez al cargar la app)
instance.interceptors.request.use((config) => {
	const token = obtenerToken();
	if (token) {
		config.headers['authorization'] = `Bearer ${token}`;
	}
	return config;
});

export default instance;
